import NewsletterInputNameProvider from './hooks/useNewsletterInputName';

import { NewsletterInputNameProps } from './@types/NewsletterInputNameProps';
import NewsletterInputNameContainer from './handles/NewsletterInputNameContainer';

const NewsletterInputName = (props: NewsletterInputNameProps) => (
	<NewsletterInputNameProvider {...props}>
		<NewsletterInputNameContainer />
	</NewsletterInputNameProvider>
);

export default NewsletterInputName;
